module.exports = __webpack_public_path__ + "assets/img/Novo_MRT Lady_RGB_hr.1965c2e5.png";